"use client";

import { trpcApi } from "@lattice/frontend/lib/trpc/client/index";
import { AlertTriangle } from "lucide-react";
import { Tooltip } from "@lattice/frontend/components/ui/tooltip";

export default function ExclusionTags({ symbol }: { symbol: string }) {
  const { data: exclusionData } = trpcApi.stock.get_exclusion_tags.useQuery({
    symbol,
  });

  if (!exclusionData) return null;

  return (
    <div className="w-full flex items-center gap-2">
      <Tooltip content={exclusionData.reason} position="right">
        <ul className="flex gap-2 overflow-x-auto scrollbar-none min-w-0">
          {exclusionData.tags.map((tag) => (
            <li
              key={tag}
              className="flex items-center gap-1.5 px-2.5 py-0.5 rounded-lg backdrop-blur-sm shadow-sm text-xs font-semibold bg-destructive/10 border border-destructive/20 whitespace-nowrap"
            >
              <AlertTriangle className="w-3 h-3 text-destructive flex-shrink-0" />
              <span className="text-destructive lowercase tracking-wider">
                {tag}
              </span>
            </li>
          ))}
        </ul>
      </Tooltip>
    </div>
  );
}
